export default __webpack_public_path__ + "static/media/blake.58e40846.jpg";